module.exports = __webpack_public_path__ + "img/xuchang2.56c07993.png";